import Facebook from './channels/Facebook';
import Website from './channels/Website';
import Twitter from './channels/Twitter';
import Api from './channels/Api';
import ApiWhatsappSelect from './channels/ApiWhatsappSelect';
import ApiSms from './channels/ApiSms.vue';
import Email from './channels/Email';
import Sms from './channels/Sms';
import Whatsapp from './channels/Whatsapp';
import Line from './channels/Line';
import Telegram from './channels/Telegram';
import Tiktok from './channels/Tiktok';
import ApiIncomingCalls from './channels/ApiIncomingCalls';
import HubOnboarding from './channels/HubOnboarding'; // d99d 99hub

const channelViewList = {
  facebook: Facebook,
  facebook2: Facebook, // d99d
  website: Website,
  twitter: Twitter,
  api: Api,
  email: Email,
  sms: Sms,
  whatsapp: Whatsapp,
  line: Line,
  telegram: Telegram,
  api_whatsapp_select: ApiWhatsappSelect,
  api_sms: ApiSms,
  tiktok: Tiktok,
  api_incoming_calls: ApiIncomingCalls,
  // d99d 99hub — all four share one onboarding-link component
  hub_fb_page: HubOnboarding,
  hub_ig_page: HubOnboarding,
  hub_fb_messenger: HubOnboarding,
  hub_ig_messenger: HubOnboarding,
};

const channelPropList = {
  email: { title: 'INBOX_MGMT.ADD.EMAIL_CHANNEL.TITLE' },
  sms: { title: 'INBOX_MGMT.ADD.SMS.TITLE' },
  api_whatsapp_select: { title: 'INBOX_MGMT.ADD.WHATSAPP.TITLE', subTitle: 'All API versions' },
  api_sms: { title: 'INBOX_MGMT.ADD.SMS.TITLE' },
  facebook2: { channel: 'facebook2' }, // d99d
  api_incoming_calls: { title: 'INBOX_MGMT.ADD.INCOMING_CALLS.TITLE' },
  // d99d 99hub — channelType is the backend Channel type; title/description are i18n keys
  hub_fb_page: {
    channelType: 'hub_facebook_page',
    title: 'INBOX_MGMT.ADD.HUB.FB_PAGE.TITLE',
    description: 'INBOX_MGMT.ADD.HUB.FB_PAGE.DESC',
  },
  hub_ig_page: {
    channelType: 'hub_instagram_page',
    title: 'INBOX_MGMT.ADD.HUB.IG_PAGE.TITLE',
    description: 'INBOX_MGMT.ADD.HUB.IG_PAGE.DESC',
  },
  hub_fb_messenger: {
    channelType: 'hub_facebook_messenger',
    title: 'INBOX_MGMT.ADD.HUB.FB_MESSENGER.TITLE',
    description: 'INBOX_MGMT.ADD.HUB.FB_MESSENGER.DESC',
  },
  hub_ig_messenger: {
    channelType: 'hub_instagram_messenger',
    title: 'INBOX_MGMT.ADD.HUB.IG_MESSENGER.TITLE',
    description: 'INBOX_MGMT.ADD.HUB.IG_MESSENGER.DESC',
  },
};

export default {
  create() {
    return {
      props: {
        channel_name: {
          type: String,
          required: true,
        },
      },
      name: 'new-channel-view',
      render(h) {
        return h(channelViewList[this.channel_name] || null, {
          props: channelPropList[this.channel_name]
        });
      },
    };
  },
};
